import { useEffect } from 'react';

interface SEOHeadProps {
  title: string;
  description: string;
  canonicalUrl?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({ title, description, canonicalUrl, schema }: SEOHeadProps) {
  useEffect(() => {
    document.title = title;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical && canonicalUrl) {
      canonical.setAttribute('href', canonicalUrl);
    }
  }, [title, description, canonicalUrl]);

  useEffect(() => {
    if (schema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      script.id = 'json-ld';
      const existing = document.getElementById('json-ld');
      if (existing) existing.remove();
      document.head.appendChild(script);
      return () => {
        const el = document.getElementById('json-ld');
        if (el) el.remove();
      };
    }
  }, [schema]);

  return null;
}